<template>
    <div>
        <b-row class="">
            <b-col class="m-0 p-0 pr-2 pl-2">
                <div class="d-flex justify-content-end">
                    <a href="#" @click.prevent><em class="descargar_todo" @click="descargarTodosComoZip" style="width: 8em;"></em></a>
                </div>
               <div class="mt-4">
                    <b-row class="text-left w-100 m-0" style="color: #00254C; font-weight: 600;">
                    <b-col>
                        <p>Nombre</p>
                    </b-col>
                    <b-col>
                       <p>Etapa</p>
                    </b-col>
                    <b-col>
                        <p>Tipo</p>
                    </b-col>
                    <b-col>
                        <p>Fecha de creación</p>
                    </b-col>
                    <b-col cols="1"></b-col>
                    </b-row>

                    <div v-if="listaDocumentos != undefined && listaDocumentos.length > 0">
                    <div class="" v-for="(document, index) in listaDocumentos" v-bind:key="index">
                        <b-row class="text-left w-100 m-0 p-0 pt-1 pb-1 mt-2 documentRegister d-flex align-items-center"
                               :class="{'selectedDocument': documentoSeleccionado == index}"
                               @click="selectDocument(index)"
                               style="cursor: pointer"
                        >
                        <b-col>
                            <p class="">{{ document.nombreArchivo }}</p>
                        </b-col>
                        <b-col>
                          <p class="">{{ obtenerEtapaArchivo(document.idEtapaProceso) }}</p>
                        </b-col>
                        <b-col>
                          <p class="">{{ obtenerTipoArchivo(document.idEtapaProceso) }}</p>
                        </b-col>
                        <b-col>
                            <p class="">{{document.fechaCreacion | formatoFechaHora}}</p>
                        </b-col>
                        <b-col cols="1">
                            <em class="download" @click.prevent="downloadBase64File()"></em>
                        </b-col>
                        </b-row>
                      <hr>
                    </div>
                    </div>
                    <div v-else class="d-flex justify-content-center align-items-center" style="min-height: 64vh;">
                    <p>Sin documentos encontrados</p>
                    </div>
               </div>
            </b-col>
            <b-col v-if="!comentarios" lg="5" style="border-left: 1px solid #EBEBEB;">
                <div v-if="documentoSeleccionado !== null">
                <template v-if="tipoMimeSeleccionado && tipoMimeSeleccionado === 'application/pdf'">
                    <iframe title="visorPdf"
                        :src="'data:application/pdf;base64,' + listaDocumentos[documentoSeleccionado].imagenBase64"
                        width="100%"
                        style="height: 50vh;"
                    ></iframe>
                </template>

                <template v-else-if="tipoMimeSeleccionado && tipoMimeSeleccionado.startsWith('image/')">
                    <img alt="file"
                        :src="'data:' + tipoMimeSeleccionado + ';base64,' + listaDocumentos[documentoSeleccionado].imagenBase64"
                        style="max-width: 100%; max-height: 50vh; display: block; margin: auto;"
                    />
                </template>

                <div v-else class="d-flex justify-content-center align-items-center" style="min-height: 35vh;">
                    <p class="text-center mt-4">Formato de archivo no soportado, por favor seleccione otro</p>
                </div>
            </div>
            <div v-else class="d-flex justify-content-center align-items-center" style="min-height: 35vh;">
                <p>Seleccione el archivo del que desea obtener la vista previa</p>
            </div>
            </b-col>
        </b-row>
    </div>
  </template>
  <script >
  import * as JSZip from "jszip";
  import { saveAs } from 'file-saver'
  import {GetObjectCommand, S3Client} from "@aws-sdk/client-s3";
  import moment from "moment/moment";
  import {AwsService} from "@/apiServices/aws/AwsService";
  export default {
    name: "VisualizadorArchivos",
    components: {},
    props: {
      idPaciente: {
        type: Number,
        default: null
      },
      listaDocumentos: Array,
      comentarios: Boolean
    },
    data: () => ({
      token: null,
      awsServicio: new AwsService(),
      imagenBase64: null,
      documentoSeleccionado: null,
      tipoMimeSeleccionado: null,
      isMobile: window.innerWidth <= 767,
      isTablet: window.innerWidth > 767 && window.innerWidth <= 1023,
      isDesktop: window.innerWidth > 1023,
   }),
    mounted() {
      window.addEventListener('resize', this.checkScreenSize);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.checkScreenSize);
    },
    created(){
      this.getArchivosBase64();
    },
    computed: {
       
    },
    methods: {
        getMimeType(dataUrl) {
    const matches = dataUrl.match(/^data:(.+);base64,/);
    if (matches && matches[1]) {
        return matches[1]; // Ej: "image/jpeg"
    }

    try {
        const base64Sample = dataUrl.slice(0, 100); 
        const binary = atob(base64Sample); 

        // Detectar PDF
        if (binary.startsWith('%PDF')) return 'application/pdf';

        // Detectar JPEG
        if (binary.charCodeAt(0) === 0xFF && binary.charCodeAt(1) === 0xD8) return 'image/jpeg';

        // Detectar PNG
        if (
            binary.charCodeAt(0) === 0x89 &&
            binary.charCodeAt(1) === 0x50 &&
            binary.charCodeAt(2) === 0x4E &&
            binary.charCodeAt(3) === 0x47
        ) return 'image/png';


    } catch (error) {
        console.warn('Error detectando tipo MIME:', error);
    }

    return null;
},

        getBase64Data(dataUrl) {
        const base64Index = dataUrl.indexOf('base64,');
        if (base64Index !== -1) {
            return dataUrl.substring(base64Index + 7); 
        }
        return null;
        },


        checkScreenSize() {
            const width = window.innerWidth;
            this.isMobile = width <= 767;
            this.isTablet = width > 767 && width <= 1023;
            this.isDesktop = width > 1023;
          },
        selectDocument(index){
            if(!this.isDesktop){
                this.modalDocumento = true;
            }
            this.documentoSeleccionado = index;
            this.tipoMimeSeleccionado = this.getMimeType(this.listaDocumentos[index].imagenBase64);
            this.imagenBase64 = this.getBase64Data(this.listaDocumentos[index].imagenBase64);
        },
        cerrarDocumento(){
            this.modalDocumento = false;
            this.documentoSeleccionado = null;
        },
      downloadBase64File() {
        const doc = this.listaDocumentos[this.documentoSeleccionado];
        const extension = doc.extension;

        // Mapa de extensiones a tipos MIME
        const mimeTypes = {
          pdf: 'application/pdf',
          png: 'image/png',
          jpg: 'image/jpeg',
          jpeg: 'image/jpeg',
          svg: 'image/svg+xml'
        };

        const mimeType = mimeTypes[extension] || 'application/octet-stream';

        const linkSource = `data:${mimeType};base64,${doc.imagenBase64}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = doc.nombreArchivo;
        downloadLink.click();

        this.loaderDescargar = false;

        this.$swal.fire({
          icon: "success",
          title: "Archivo descargado correctamente",
          showConfirmButton: false,
          timer: 1500,
        });
      },

      async descargarTodosComoZip() {
        const zip = new JSZip();

        this.listaDocumentos.forEach((doc, index) => {
          let base64Data = doc.imagenBase64;

          // Quitar prefijo "data:*;base64," si existe
          const matches = base64Data.match(/^data:.*;base64,(.*)$/);
          const content = matches ? matches[1] : base64Data;

          // Armar nombre final con extensión conocida
          const extension = doc.extension?.toLowerCase() || 'bin';
          const nombreArchivo = `${doc.nombreArchivo || 'documento'}_${index + 1}.${extension}`;

          zip.file(nombreArchivo, content, { base64: true });
        });

        const contenidoZip = await zip.generateAsync({ type: 'blob' });
        saveAs(contenidoZip, 'DocumentosPaciente.zip');

        this.$swal.fire({
          icon: 'success',
          title: 'Archivos descargados correctamente',
          showConfirmButton: false,
          timer: 1500
        });
      },

      async getArchivosBase64() {
        await this.validarTokenAWS();

        let config = {
          region: this.token.regionBucket,
          credentials: {
            accessKeyId: this.token.accessKeyId,
            secretAccessKey: this.token.secretAccessKey,
            sessionToken: this.token.sessionToken,
          },
        };
        const client = new S3Client(config);

        for (let archivo of this.listaDocumentos) {
          try {
            const input = {
              Bucket: this.token.nombreBucket,
              Key: archivo.urlRuta, // Ahora sí recorremos la lista
            };
            const command = new GetObjectCommand(input);
            const response = await client.send(command);

            const responseS3 = await new Response(response.Body);
            const imageBlob = await responseS3.blob();

            // Convertir a Base64 usando una Promesa
            archivo.imagenBase64 = await this.convertBlobToBase64(imageBlob);

          } catch (error) {
            console.error(`Error al obtener ${archivo.Key}:`, error);
          }
        }

        console.log(this.listaDocumentos);
      },

      convertBlobToBase64(blob) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            const base64String = reader.result.split(",")[1];
            resolve(base64String);
          };
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      },

      async validarTokenAWS() {
        if (this.token !== null) {
          if (this.token.expireTo < moment(new Date()).format("YYYY-MM-DD HH:mm:ss")) {
            await this.awsServicio.obtenerTokenAcceso().then((response) => {
              this.token = response.data
              this.$localStorageService.setTokenAWS(this.token)
            })
          }else{
            if(typeof this.token === 'string'){
              this.token = JSON.parse(this.token);
            }
          }
        } else {
          await this.awsServicio.obtenerTokenAcceso().then((response) => {
            this.token = response.data
            this.$localStorageService.setTokenAWS(this.token)
          })
        }
      },

      obtenerEtapaArchivo(idEtapa){
        if (idEtapa === undefined || idEtapa === null) return 'Inicio Laboratorio';
        if (idEtapa === 102) return 'Inicio Laboratorio'
        if (idEtapa === 104) return 'Mesa de trabajo';
        if (idEtapa === 106) return 'Produccion';
        if (idEtapa === 109) return 'Rechazo Mesa de trabajo';
        if (idEtapa === 110) return 'Rechazo Calidad';

      },

      obtenerTipoArchivo(idEtapa){
        if (idEtapa === undefined || idEtapa === null) return 'Clinica';
        if (idEtapa === 102) return 'Clinica'
        if (idEtapa === 104) return 'Evidencia';
        if (idEtapa === 106) return 'Evidencia';
        if (idEtapa === 109) return 'Rechazo';
        if (idEtapa === 110) return 'Rechazo';
      }


    }
  }
  </script>
  <style scoped>
    p{
        font-size: .9em;
        margin: 0px;
        padding: 0px;
    }
    .selectedDocument{
        background-color: #F2F8FC ;
        border: 1px solid #C2DFF1;
        font-size: .85em;
        border-radius: 50px;
    }

    .documentRegister{
        font-size: .85em;
    }
  </style>
